import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { tabletUp, mobileOnly, setOpacity } from 'styles/utils';
import { colors } from 'styles/theme';

import PlayIconSvg from 'public/media/info-center/play-icon.svg';
import PlayCircleIconSvg from 'public/media/info-center/play-circle-icon.svg';

import Paper from '../Paper/Paper';

const playIconPaperCss = cardOnly => css`
  &.MuiPaper-root {
    display: flex;
    position: absolute;
    right: 0;
    transform: translate(-17px, -50%);
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    height: 57px;
    width: 57px;

    ${mobileOnly} {
      display: ${!cardOnly && 'none'};
    }
  }
`;

const mobileIconCss = css`
  ${mobileOnly} {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    background-color: ${setOpacity(colors.darkPurple, 0.5)};
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    border-radius: 5px;
  }

  ${tabletUp} {
    display: none;
  }
`;

const playCircleSvgCss = css`
  circle {
    display: none;
  }
`;

function VideoPlayIcon({ cardOnly }) {
  return (
    <>
      <Paper css={playIconPaperCss(cardOnly)}>
        <PlayIconSvg />
      </Paper>

      {!cardOnly && (
        <div css={mobileIconCss}>
          <PlayCircleIconSvg css={playCircleSvgCss} />
        </div>
      )}
    </>
  );
}

VideoPlayIcon.propTypes = {
  cardOnly: PropTypes.bool,
};

export default VideoPlayIcon;
